module.exports = __webpack_public_path__ + "images/mdj/members/mypage/top/top_img02-7ab5a9aee8323309b87079c9968fe702.png";